document.addEventListener('DOMContentLoaded', () => {
  let hasSubscriptionItem = false;
  let hasOneTimeItem = false;
  let totalPrice = 0;

  const handleCartErrorDisplay = () => {
    const errorNode = document.querySelector('.rebuy-cart__flyout .mixed-cart-error');

    if (hasSubscriptionItem && hasOneTimeItem && !errorNode) {
      createErrorNode();
    } else if (!hasSubscriptionItem || !hasOneTimeItem) {
      errorNode?.remove();
    }
  };

  document.addEventListener('rebuy:cart.change', (event) => {
    hasSubscriptionItem = event.detail.cart
      .items()
      .some((item) => item.selling_plan_allocation?.selling_plan.options[0].name.includes('Recharge'));
    hasOneTimeItem = event.detail.cart
      .items()
      .some((item) => !item.selling_plan_allocation?.selling_plan.options[0].name.includes('Recharge'));
    totalPrice = event.detail.cart.cart.total_price;
    handleCartErrorDisplay();
  });

  document.addEventListener('rebuy:cart.ready', () => {
    handleCartErrorDisplay();
  });

  const createErrorNode = () => {
    const errorNode = document.createElement('div');
    errorNode.className = 'mixed-cart-error';
    errorNode.innerHTML = `
            <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
            </svg>
            <span>${window.cartStrings.mixedCart}</span>
        `;

    document.querySelector('.rebuy-cart__flyout-items')?.prepend(errorNode);
  };
});
